/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Pricing_Billed_AnnuallyInputs */

const en_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Billed EUR ${i?.amount} / year`)
};

const de_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jährliche Abrechnung EUR ${i?.amount} / Jahr`)
};

const fr_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturé EUR ${i?.amount} / an`)
};

const es_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturado EUR ${i?.amount} / año`)
};

const it_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fatturato EUR ${i?.amount} / anno`)
};

const nl_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gefactureerd EUR ${i?.amount} / jaar`)
};

const pl_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rozliczane EUR ${i?.amount} / rok`)
};

const fi_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laskutettu EUR ${i?.amount} / vuosi`)
};

const da_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faktureret EUR ${i?.amount} / år`)
};

const sv_pricing_billed_annually = /** @type {(inputs: Pricing_Billed_AnnuallyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faktureras EUR ${i?.amount} / år`)
};

/**
* | output |
* | --- |
* | "Billed EUR {amount} / year" |
*
* @param {Pricing_Billed_AnnuallyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_billed_annually = /** @type {((inputs: Pricing_Billed_AnnuallyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Billed_AnnuallyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_billed_annually(inputs)
	if (locale === "fr") return fr_pricing_billed_annually(inputs)
	if (locale === "es") return es_pricing_billed_annually(inputs)
	if (locale === "it") return it_pricing_billed_annually(inputs)
	if (locale === "nl") return nl_pricing_billed_annually(inputs)
	if (locale === "pl") return pl_pricing_billed_annually(inputs)
	if (locale === "fi") return fi_pricing_billed_annually(inputs)
	if (locale === "da") return da_pricing_billed_annually(inputs)
	if (locale === "sv") return sv_pricing_billed_annually(inputs)
	return en_pricing_billed_annually(inputs)
});